module.exports = __webpack_public_path__ + "static/bg.800ea030.png";